import axios from 'axios';
import endpoint from '../Endpoint';
import JwtDecoder from './jwt';
import IdentifyClient from './client'
import {
    clearStoredSession,
    getStoredRole,
    getStoredRoleType,
    getStoredToken,
    normalizeFrontendUserType,
    setStoredSession,
} from '../services/auth.service';

export const axiosPublic = axios.create({
    baseURL: endpoint,
    headers: {
        "Content-Type": "application/json",
        "x-auth-nam": "j34n2ton5otn2452t394t9f2n49",
        "client": `${IdentifyClient.getDeviceId()}`
    }
});

class AxiosService {
    accessTokenKey = 'atht';
    refreshTokenKey = 'rtht';
    idTokenKey = 'iduht';
    hname = "hname";
    roleKey = "role";
    roleTypeKey = "role-type";

    constructor(endpoint) {
        this.endpoint = endpoint;
        this.initializeInterceptors();
    }

    getToken() {
        return getStoredToken();
    }

    getUserName() {
        return localStorage.getItem(this.hname);
    }

    setToken(token) {
        setStoredSession({ token });
    }

    setRole(role) {
        if (role) localStorage.setItem(this.roleKey, normalizeFrontendUserType(role));
    }

    getRole() {
        return getStoredRole();
    }

    setTypeRole(roleType) {
        if (roleType) localStorage.setItem(this.roleTypeKey, normalizeFrontendUserType(roleType));
    }

    getTypeRole() {
        return getStoredRoleType();
    }

    getRefreshToken() {
        return localStorage.getItem(this.refreshTokenKey);
    }

    setRefreshToken(refreshToken) {
        if (refreshToken) localStorage.setItem(this.refreshTokenKey, refreshToken);
    }

    getIdToken() {
        return localStorage.getItem(this.idTokenKey);
    }

    setIdToken(idToken) {
        localStorage.setItem(this.idTokenKey, idToken);
    }

    setUserName(name) {
        localStorage.setItem(this.hname, name);
    }

    closeSession() {
        clearStoredSession();
        window.location.reload();
    }

    async getPayloadRaw() {
        if (this.isAuthenticated()) {
            const token = this.getToken();
            return JwtDecoder.decode(token);
        } else {
            return null;
        }
    }

    async getPayload() {
        if (this.isAuthenticated()) {
            const token = this.getToken();
            const payload = JwtDecoder.decode(token);
            return await axios.get(`/auth/api/profile/${payload.username}`);
        } else {
            return null;
        }
    }

    isAuthenticated() {
        return Boolean(this.getToken());
    }

    async refreshToken(token) {
        try {
            const payload = JwtDecoder.decode(token);
            const response = await axios.post(`${this.endpoint}/auth/refresh`, {
                refreshToken: this.getRefreshToken(),
                username: payload.username
            });

            this.setToken(response.data.accessToken);
            return response.data.accessToken;
        } catch (error) {
            this.closeSession();
            throw error;
        }
    }

    initializeInterceptors() {
        axios.interceptors.request.use((config) => {
            const token = this.getToken();
            config.baseURL = this.endpoint;
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            if (config.data instanceof FormData) {
                delete config.headers["Content-Type"];
            } else {
                config.headers["Content-Type"] = "application/json";
            }
            return config;
        }, (error) => {
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => response, async (error) => {
            const originalRequest = error.config || {};

            if (error.response && error.response.status === 401 && !originalRequest._retry) {
                this.closeSession();
                return Promise.reject(error.response || error);
            } else if (error.response && error.response.status === 403) {
                this.closeSession();
            }

            return Promise.reject(error.response || error);
        });
    }
}

export default new AxiosService(endpoint);
